
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 11.5c0-5.43-5.934-9.19-10.85-6.707l-.003.002c-3.618 1.808-5.19 6.419-3.354 10.054a1 1 0 01.056.767L4.58 19.42l3.803-1.268a1 1 0 01.767.056c4.857 2.452 10.864-1.367 10.85-6.705V11.5zm2-.001c0-6.885-7.474-11.66-13.749-8.493-4.467 2.234-6.475 7.79-4.427 12.36l-1.773 5.318a1 1 0 001.265 1.265l5.318-1.773C14.771 22.932 22.016 18.16 22 11.5z"}})])
          )
        }
      }
    